import React from 'react'
import RetailTotalBetsBadge from './RetailTotalBetsBadge'
import RetailRoundId from './RetailRoundId'
import AllShopsTab from '../bets-tabs/AllShopsTab'
import RetailNow from './RetailNow'
import { RetailContextProvder } from '../../contexts/RetailTickets'

export default function MainRetail() {

  return (
    <div
      style={{
        display: "flex",
      }}
    >
      <div className={"desktop-background retail"}></div>
      <div className={"container container-retail"}>
        <div className={"desktop-container retail "}>
          <div className={"desktop-left retail "}>
            <div className="desktop-section-title">
             <RetailTotalBetsBadge />
            </div>
            <div className="position-relative desktop-left-height">
            <div className="pod-tabs-panel-holder container">
            <RetailContextProvder>
              <AllShopsTab />
            </RetailContextProvder>
              <div className="desktop-left-bottom-background">
                <div className="app-version">v1.4</div>
              </div>
            </div>
            </div>
          </div>
          <div className={"desktop-middle retail"}>
            <RetailRoundId />
            <div
              className={"desktop-dialog"}
            >
              <div className="desktop-bet-info-holder">
              </div>
            </div>
            <RetailNow />
          </div>
        </div>
      </div>
    </div>
  )
}
